import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from 'components/Layout';
import ContactDetails from 'components/Contact/ContactDetails';

const ContactPage: FC = () => {
    const { t } = useTranslation();
    const { id } = useParams<Record<string, string>>();

    return (
        <Layout pageTitle={t('page.contact-details.meta-title')}>
            <ContactDetails id={id} />
        </Layout>
    );
};

export default ContactPage;
